import QRious from 'qrious';

// convertToQrCodeImageDataUrl takes a string and returns a base64 encoded QR code image.  size is optional and
// defaults to 500.
export const convertToQrCodeImageDataUrl = (text: string, size = 500): string => {
  const qr = new QRious({
    value: text,
    size
  });

  const dataUrlParts = qr.toDataURL().split(',');

  if (!dataUrlParts[1]) {
    throw new Error('Failed to generate QR code image data URL');
  }

  return dataUrlParts[1];
};
